<template>
  <div class="py-5">
    <validation-observer ref="inputRules">
      <b-row>
        <b-col cols="12">
          <b-link to="/" class="brand-logo ml-5"
            ><img
              src="data:image/png;base64,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"
              alt="logo"
              class=""
              style="max-width: 150px"
            /> </b-link
        ></b-col>

        <b-col cols="12" class="w-100 text-center"> </b-col>

        <b-col cols="12" lg="5" class="justify-content-center m-auto pb-4 px-4">
          <h2 class="mb-1">Track your parcel</h2>
          <b-form-group class="m-0">
            <b-input-group>
              <b-form-input
                ref="inputSearchTrack"
                @keydown.enter.native="getDataTrackTrace"
                v-model.trim="idBooking"
                :placeholder="$t('submitTracking')"
                class="round"
              />

              <div class="input-group-append" @click="getDataTrackTrace">
                <span class="input-group-text round"
                  ><feather-icon icon="SearchIcon"
                /></span>
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>
    <div v-if="!loading">

      <transition name="slide-fade">
        <b-card-text v-if="request_quotation">
          <!-- <track-trace
            :track_trace="track_trace_status"
            :shipment="shipment"
            :isNoLogin="true"
            :request_quotation="request_quotation"
            :shipment_on_fast="shipment_on_fast"
            :shipment_on_tms="shipment_on_tms"
          /> -->
          <TrackTracePublic
            :track_trace="track_trace_status"
            :shipment="shipment"
            :isNoLogin="true"
            :bookingID="idBooking"
            :bookingInfo="bookingInfo"
            :request_quotation="request_quotation"
            :shipment_on_fast="shipment_on_fast"
            :shipment_on_tms="shipment_on_tms"
          />
        </b-card-text>
        <b-card-text
          v-else-if="request_quotation == '' && idBooking"
          class="text-center"
        >
          <p
            class="sm:mx-0 mx-4 sm:mb-12 mb-8 d-theme-text-inverse pb-5 text-danger"
            style="font-size: 18px"
          >
            Shipping line not found! Please check the reference number. 
          </p>
          <img
            width="70%"
            src="@/assets/images/pages/bg_tt.png"
            alt="graphic-not-authorized"
            class="mx-auto mb-4"
          />

          <!-- <b-button
            variant="primary"
            class="mb-2 mt-2 btn-sm-block"
            :to="{ path: '/' }"
          >
            Back to home
          </b-button> -->
        </b-card-text>

        <b-card-text v-else class="text-center">
         
          <img
            width="70%"
            src="@/assets/images/pages/bg_tt.png"
            alt="graphic-not-authorized"
            class="mx-auto mb-4"
          />

          
          <!-- <b-button
            variant="primary"
            class="mb-2 mt-2 btn-sm-block"
            :to="{ path: '/' }"
          >
            Back to home
          </b-button> -->
        </b-card-text>
      </transition>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import vSelect from "vue-select";
import Select2 from "v-select2-component";

import {
  ref,
  reactive,
  watch,
  computed,
  onUnmounted,
} from "@vue/composition-api";

import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { VueGoodTable } from "vue-good-table";
import "@core/scss/vue/libs/vue-good-table.scss";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import trackTrace from "@/mixin/trackTrace.js";

export default {
  mixins: [trackTrace],
  components: {
    VuexyLogo,
    vSelect,
    FeatherIcon,
    ValidationProvider,
    ValidationObserver,
    Select2,
    VueGoodTable,
    TrackTracePublic: () => import("@/views/wr1/quotation/TrackTracePublic.vue"),
  },
  data() {
    return {
      loading: false,
      idBooking: "",
      shipment: null,
      request_quotation: null,
      bookingInfo: null,
    };
  },
  watch: {
    idBooking(n) {
      n == "" ? (this.request_quotation = null) : "";
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this.$refs.inputSearchTrack.focus();
      this.idBooking = this.$route.query.id;
      this.getDataTrackTrace();
    }
  },
  methods: {
    async getDataTrackTrace() {
      this.$loading.show();
      this.loading = true;

      await useJwt
        .get("wr1Nologin?objectType=ClientBooking", {
          params: {
            search: { bookingId: this.idBooking },
          },
        })
        .then((response) => {
          if (response.data.result.length > 0) {
            this.shipment = JSON.parse(response.data.result[0].shipment_info);
            this.bookingInfo = response.data.result[0];
            this.shipment_on_fast = JSON.parse(
              response.data.result[0].shipment_on_fast_info
            );
            if (response.data.result[0].shipment_on_tms_info != null) {
              this.shipment_on_tms = JSON.parse(
                response.data.result[0].shipment_on_tms_info
              );
            }

            this.request_quotation = JSON.parse(
              response.data.result[0].request_quotation_info
            );
            this.request_quotation.bookingID = this.idBooking;
            this.loadTrackTrace();
            return;
          }else{
            this.request_quotation = "";

          }
        })
        .finally(() => {
          this.$loading.hide();
          this.$nextTick(() => {});
          this.loading = false;
        });
    },
  },
};
</script>
<style>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* Trước 2.1.8 thì dùng .slide-fade-leave-active */ {
  transform: translateX(10px);
  opacity: 0;
}
.select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    center / contain no-repeat;
}
.select2-selection__arrow {
  background: none;
  display: none !important;
}
.vgt-table td,
.vgt-table th {
  vertical-align: middle !important;
  font-size: 1rem;
}
.vgt-table th {
  text-align: center;
}
</style>
<style lang="scss" scoped>
.timeline {
  margin-top: 100px;
  width: 100%;
  background: fff;
  position: relative;
  padding: 0px 50px;

  &:before {
    content: "";
    position: absolute;
    top: 0px;
    left: calc(33% + 15px); //$gutter/2
    bottom: 0px;
    width: 4px;
    background: #525252;
  }
  &:after {
    content: "";
    display: table;
    clear: both;
  }
}

.entry {
  clear: both;
  text-align: left;
  position: relative;
  &:first-child {
    padding-bottom: 80px;
  }
  .title {
    margin-bottom: 0.5em;
    float: left;
    width: 33%;
    padding-right: 30px;
    text-align: right;
    position: relative;
    top: -15px;
    &:before {
      content: "";
      position: absolute;
      width: 8px;
      height: 8px;
      border: 8px solid salmon;
      background-color: #fff;
      border-radius: 100%;
      top: 13px;
      right: -8px;
      z-index: 99;
    }

    h3 {
      margin: 0;
      font-size: 120%;
      &:first-child {
        padding-right: 20px;
      }
    }
  }

  .end {
    margin-bottom: 0.5em;
    float: left;
    width: 33%;
    padding-right: 30px;
    text-align: right;
    position: relative;
    top: 33px;
    &:before {
      content: "";
      position: absolute;
      width: 8px;
      height: 8px;
      border: 8px solid salmon;
      background-color: #fff;
      border-radius: 100%;
      top: 13px;
      right: -8px;
      z-index: 99;
    }

    h3 {
      margin: 0;
      font-size: 120%;
      &:first-child {
        padding-right: 20px;
      }
    }
  }
  div {
    float: left;
    max-width: 66%;
    .body {
      padding-left: 41px;
      padding-top: 0;
      margin-top: -10px;
      margin: 0;
      cursor: pointer;
      padding-bottom: 0;
      font-style: normal;
      font-weight: bold;
      font-size: 120%;
      line-height: 29px;
      color: #2a958d;

      -moz-user-select: none !important;
      -webkit-touch-callout: none !important;
      -webkit-user-select: none !important;
      -khtml-user-select: none !important;
      -moz-user-select: none !important;
      -ms-user-select: none !important;
      user-select: none !important;
    }
    .body-end {
      position: absolute;
      bottom: -65px;
      width: 64%;
      left: 32%;
    }
  }
}
.entry-body {
  padding-top: 40px;
  padding-bottom: 80px;
}
.entry-childe {
  clear: both;
  text-align: left;
  position: relative;
  .title {
    margin-bottom: 0.5em;
    float: left;
    width: 33%;
    padding-right: 30px;
    text-align: right;
    position: relative;
    &:before {
      content: "";
      position: absolute;
      width: 10px;
      height: 10px;
      border: 1px solid #2b938c;
      background-color: #fff;
      border-radius: 100%;
      top: 0;
      right: -5px;
      z-index: 99;
    }

    h3 {
      margin: 0;
      font-size: 120%;
    }
  }

  div {
    float: left;
    max-width: 66%;
    .card {
      margin-left: 40px;
      display: inline-block;
      background: #fff;
      border-radius: 5px;
      padding: 10px;
      margin-top: -17px;
      margin-bottom: 30px;

      .body {
        padding: 0;
        margin-top: 0;
        padding-bottom: 0;
        font-weight: bold;
        font-size: 120%;
        line-height: 24px;

        color: #2a958d;
      }
      p {
        margin-bottom: 0;
        font-size: var(--normal-font-size);
      }
    }
  }
}

.card-body {
  justify-content: center;
  .status-active {
    background: #4472c4 !important;
  }
  .status {
    width: 100%;
    height: 40px;
    background: #b4c7e7;
    border: 1px solid #849bc7;
    position: relative;
    overflow: hidden;
    .icon {
      position: absolute;
      top: -5px;
      .arrow1,
      .arrow2,
      .arrow3 {
        border: solid #c9c9c9;
        border-width: 0 18px 18px 0;
        @media (max-width: 1440px) {
          border-width: 0 14px 14px 0 !important;
        }
        display: inline-block;
        padding: 16px;
      }

      .right {
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
      }
    }
  }
  .caption {
    padding-top: 20px;
    text-align: center;
    font-style: italic;
    position: relative;

    .title {
      margin-bottom: 1.5rem;
    }
    &:hover .dropdown {
      opacity: 1 !important;
      visibility: visible !important;
    }
    .dropdown {
      opacity: 0;
      transition: opacity 1s, visibility 1s;
      visibility: hidden;
      position: absolute;
      background: rgba(42, 149, 141, 0.2);
      padding: 5px;
      border-radius: 15px;

      color: #000000;
      h4 {
        font-weight: bold;
        font-size: 12px;
        line-height: 18px;
        /* or 150% */

        text-align: center;
      }
      &::before {
        content: "";
        display: block;
        position: absolute;
        left: 20px;
        bottom: 100%;
        width: 0;
        height: 0;
        border-bottom: 10px solid rgba(42, 149, 141, 0.2);
        border-top: 10px solid transparent;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
      }
    }
  }
}
</style>
